import { Redirect } from 'react-router-dom'

import { isAuthenticated } from 'utils/backend'
import { LOGIN, SEARCH_PAGE } from 'utils/paths'

export const BaseRedirect = () => {
  return <Redirect to={isAuthenticated() ? SEARCH_PAGE : LOGIN} />
}
